/* eslint-disable @typescript-eslint/no-explicit-any */
import { SIMULATE_LINE } from 'domain/entities/SimulateDescEntity';

const descView = (data: any[]) => {
    const desc: SIMULATE_LINE[] = [
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 5,
                    title: '今売った時の損益',
                    value: data[0].center,
                    prefix: '万円',
                },
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '損益分岐点',
                    value: data[0].right,
                    prefix: 'ヶ月後',
                },
            ],
        },
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '現在の残債',
                    value: data[1].center,
                    prefix: '万円',
                },
                {
                    colSpan: 12,
                    titleSpan: 6,
                    title: '今売った時の総収入',
                    value: data[1].right,
                    prefix: '万円',
                },
            ],
        },
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 5,
                    title: '今売った時の支出',
                    value: data[2].center,
                    prefix: '万円',
                },
            ],
        },
    ];

    return desc;
};

export { descView };
